module.exports = __webpack_public_path__ + "img/trust_the_pain_ep.49fdcd17.jpg";